export class FieldRoutes
{
	static Home: string = `/`;
	// Field
	static FieldList: string = '/field/list';
	static FieldNew: string = '/field/new';
	static FieldCopy(id: string)
	{
		return `/field/new/${id}`;
	};
	static FieldEdit(id: string)
	{
		return `/field/${id}/edit`;
	};
	static FieldView(id: string)
	{
		return `/field/${id}/view`;
	};
	// Category
	static CategoryList: string = '/category/list';
	static CategoryNew: string = '/category/new';
	static CategoryCopy(id: string)
	{
		return `/category/new/${id}`;
	};
	static CategoryEdit(id: string)
	{
		return `/category/${id}/edit`;
	};
	static CategoryView(id: string)
	{
		return `/category/${id}/view`;
	};
	// CategoryScope
	static CategoryScopeList: string = '/category/scope/list';
	static CategoryScopeNew: string = '/category/scope/new';
	static CategoryScopeCopy(id: string)
	{
		return `/category/scope/new/${id}`;
	};
	static CategoryScopeEdit(id: string)
	{
		return `/category/scope/${id}/edit`;
	};
	static CategoryScopeView(id: string)
	{
		return `/category/scope/${id}/view`;
	};
	// Slot
	static SlotList: string = '/slot/list';
	static SlotNew: string = '/slot/new';
	static SlotCopy(id: string)
	{
		return `/slot/new/${id}`;
	};
	static SlotEdit(id: string)
	{
		return `/slot/${id}/edit`;
	};
	static SlotView(id: string)
	{
		return `/slot/${id}/view`;
	};
}